import { render, staticRenderFns } from "./student-half-round-view.vue?vue&type=template&id=1d1cb378&scoped=true&"
import script from "./student-half-round-view.ts?vue&type=script&lang=ts&"
export * from "./student-half-round-view.ts?vue&type=script&lang=ts&"
import style0 from "./student-half-round-view.scss?vue&type=style&index=0&id=1d1cb378&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d1cb378",
  null
  
)

export default component.exports